// extracted by mini-css-extract-plugin
export default {"containerActions":"styles_containerActions__Lv52p","iconAction":"styles_iconAction__CSmCy","textAction":"styles_textAction__-DppV"};